export const PERCEPTION_MODELS = [
  {
    name: 'Lucia 0.1',
    value: 'lucia-0.1'
  },
  {
    name: 'LLM CV',
    value: 'llm-cv'
  },
  {
    name: 'Off',
    value: 'off'
  }
];
